<header>
  <!-- header -->
  <app-layout-header></app-layout-header>
</header>

<main>
  <!-- Banners to display below the header -->
  <app-banner></app-banner>

  <!-- routes will be rendered here -->
  <router-outlet></router-outlet>
</main>

<!-- Loader -->
<div [appHidden]="!loader"
  class="overlay">
  <mat-progress-spinner class="spinner"
    mode="indeterminate"
    value="50">
  </mat-progress-spinner>
</div>

@if (showFilterContext$ | async) {
  <app-filter-context-menu></app-filter-context-menu>
}
